<template>
  <div id="app">
    <div id="nav">
      <Header/>
    </div>
    <Login></Login>
    <Footer class="footer"></Footer>
  </div>
</template>

<script>
import Header from '../components/Header'
import Footer from '../components/Footer'
import Login from '../components/Login'

export default {
  components: {
    Header,
    Footer,
    Login
  }
}
</script>

<style>
  #app {
    font-family: 'Ubuntu', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #000;
    font-size: 16px;
  }

  #nav {
    padding: 0px;
  }

  #nav a {
    font-weight: bold;
    color: #2c3e50;
  }

  #nav a.router-link-exact-active {
    color: #42b983;
  }

  .margin-top {
    margin-top: 100px;
  }

  .footer {
    bottom: 0;
    position: fixed;
    width: 100%;

  }

  #id {
    height: 100%;
  }
</style>
